import {
  ADD_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
  REQUEST_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
  SUCCESS_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
  FAILURE_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
  ADD_SAVED_PROGRAM_AUTOCOMPLETE,
  CLEAR_SAVED_PROGRAM_AUTOCOMPLETE,
  REQUEST_SAVED_PROGRAM_AUTOCOMPLETE,
  SUCCESS_SAVED_PROGRAM_AUTOCOMPLETE,
  FAILURE_SAVED_PROGRAM_AUTOCOMPLETE,
  ADD_SCHOOLS_AUTOCOMPLETE,
  REQUEST_SCHOOLS_AUTOCOMPLETE,
  SUCCESS_SCHOOLS_AUTOCOMPLETE,
  FAILURE_SCHOOLS_AUTOCOMPLETE,
} from './actionTypes';
import fetchErrorHandler from '../services/fetchErrorHandler';
import { getCsrfToken } from '../utils/helpers';

const savedProgramSchoolAutocompleteApiRequest = () => ({
  type: REQUEST_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
});

const savedProgramSchoolAutocompleteApiSuccess = () => ({
  type: SUCCESS_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
});

const savedProgramSchoolAutocompleteApiFailure = ({ error }) => ({
  type: FAILURE_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
  error,
});

const addSavedProgramSchoolsAutocomplete = (autocompleteList, id) => ({
  type: ADD_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
  payload: {
    autocompleteList,
    id,
  },
});

const schoolsAutocompleteApiRequest = () => ({
  type: REQUEST_SCHOOLS_AUTOCOMPLETE,
});

const schoolsAutocompleteApiSuccess = () => ({
  type: SUCCESS_SCHOOLS_AUTOCOMPLETE,
});

const schoolsAutocompleteApiFailure = ({ error }) => ({
  type: FAILURE_SCHOOLS_AUTOCOMPLETE,
  error,
});

const addSchoolsAutocomplete = (autocompleteSchools, autocompleteSchoolsId, autocompleteSchoolsDbn) => ({
  type: ADD_SCHOOLS_AUTOCOMPLETE,
  payload: {
    autocompleteSchools,
    autocompleteSchoolsId,
    autocompleteSchoolsDbn,
  },
});

export const getSavedProgamSchoolsAutocomplete = autocompleteString => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  const { applicationId } = getState().user;
  const url = `${locale}/api/${apiVersion}/application/${applicationId}/saved-programs/schools/autocomplete/?q=${autocompleteString}`;
  dispatch(savedProgramSchoolAutocompleteApiRequest());
  return fetch(`${url}`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(resp => resp.json())
    .then(data => {
      dispatch(
        addSavedProgramSchoolsAutocomplete(data.map(school => school.name), data.map(school => school.school_id)),
      );
      dispatch(savedProgramSchoolAutocompleteApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(savedProgramSchoolAutocompleteApiFailure({ error }));
    });
};

const savedProgramAutocompleteApiRequest = () => ({
  type: REQUEST_SAVED_PROGRAM_AUTOCOMPLETE,
});

const savedProgramAutocompleteApiSuccess = () => ({
  type: SUCCESS_SAVED_PROGRAM_AUTOCOMPLETE,
});

const savedProgramAutocompleteApiFailure = ({ error }) => ({
  type: FAILURE_SAVED_PROGRAM_AUTOCOMPLETE,
  error,
});

const addSavedProgramAutocomplete = savedPrograms => ({
  type: ADD_SAVED_PROGRAM_AUTOCOMPLETE,
  payload: {
    savedPrograms,
  },
});

export const clearSavedProgramsAutocomplete = () => ({
  type: CLEAR_SAVED_PROGRAM_AUTOCOMPLETE,
});

export const getSavedProgramsAutocomplete = (autocompleteString, excludeSHS = false) => async (
  dispatch,
  getState,
  { fetch },
) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  const { applicationId } = getState().user;
  let url = `${locale}/api/${apiVersion}/application/${applicationId}/add-programs/autocomplete/?q=${autocompleteString}`;
  if (excludeSHS) {
    url = `${locale}/api/${apiVersion}/application/${applicationId}/add-programs/autocomplete/?exclude_shs=true&q=${autocompleteString}`;
  }
  dispatch(savedProgramAutocompleteApiRequest());
  return fetch(`${url}`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(data => {
      dispatch(addSavedProgramAutocomplete(data));
      dispatch(savedProgramAutocompleteApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(savedProgramAutocompleteApiFailure({ error }));
    });
};

export const getSchoolsAutocomplete = ({
  //
  query,
  options = null,
  latLng = '',
  processName = 'high-school',
}) => async (
  //
  dispatch,
  getState,
  { fetch },
) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  const { applicationId } = getState().user;
  const processId = getState().admissionInstances[processName];
  // If logged in, use application ApplicationSchoolAutocomplete view
  let url = `${locale}/api/${apiVersion}/schools/process/${processId}/autocomplete/?q=${encodeURIComponent(query)}`;
  if (applicationId) {
    url = `${locale}/api/${apiVersion}/application/${applicationId}/schools/autocomplete/?q=${encodeURIComponent(
      query,
    )}`;
  }
  if (options) {
    Object.entries(options).map(([path, values]) => {
      values.map(value => {
        url += `&${path}=${value}`;
      });
    });
  }
  if (latLng) {
    url += `&${latLng}`;
  }
  dispatch(schoolsAutocompleteApiRequest());
  return fetch(`${url}`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(data => {
      dispatch(
        addSchoolsAutocomplete(
          data.results.map(school => school.name),
          data.results.map(school => school.id),
          data.results.map(school => school.dbn),
        ),
      );
      dispatch(schoolsAutocompleteApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(schoolsAutocompleteApiFailure({ error }));
    });
};
